import React from "react";
import "./healthplan.scss";
import {
  androidButton,
  bookingImg,
  compareimg,
  iosButton,
  QRcodeImg,
  steptodownimg,
} from "../../assets/images";
import { Link } from "react-router-dom";
import { arrow_icon, liheart } from "../../assets/icons";
import Select from "react-select";
import { Button } from "../../component/form";
import OurHealthPlan from "./section/OurHealthPlan";
import { Helmet } from "react-helmet";

const HealthPlan = () => {
  // const orgnaizationData = {
  //   "@context": "https://schema.org",

  //   "@type": "MedicalOrganization",

  //   name: "Holypills",

  //   alternateName: "Holypills Homeopathy Platform",

  //   url: "https://www.holypills.in",

  //   logo: "https://holypills.in/static/media/logoblk.85a98ca03ea02020c9410dbb9412a5f5.svg",

  //   image: "https://www.holypills.in/banner.jpg",

  //   description:
  //     "Holypills is a trusted homeopathy care platform for women’s health. From PCOS and Endometriosis to Menopause and Postpartum recovery, we provide personalized remedies and app-based tracking to help you heal naturally.",

  //   founder: {
  //     "@type": "Person",

  //     name: "Dr. Ila Kathuria",

  //     jobTitle: "Co-Founder & Chief Homeopathy Consultant",

  //     image:
  //       "https://holypills.in/static/media/founder.643f6d9fcb22ed9aaddd.jpeg",

  //     description:
  //       "Dr. Ila Kathuria, a distinguished name in women’s health and one of India’s foremost advocates of personalized, integrative care. With over 35 years of clinical experience, Dr. Kathuria has consistently challenged the status quo in women’s healthcare by blending the depth of homeopathy with the precision of modern medical insight.",
  //   },

  //   foundingDate: "2025",

  //   sameAs: [
  //     "https://www.facebook.com/holypillscare",

  //     "https://www.instagram.com/holypillscare",

  //     "https://www.linkedin.com/company/holypillscare",

  //     "https://www.youtube.com/@Holypillscare",
  //   ],

  //   contactPoint: {
  //     "@type": "ContactPoint",

  //     telephone: "+91-9999887833",

  //     contactType: "customer service",

  //     availableLanguage: ["English", "Hindi"],
  //   },

  //   address: {
  //     "@type": "PostalAddress",

  //     streetAddress:
  //       "Connaught Place 4 - S, DCM Building Barakhamba Road, Landmark: Near Metro Station, Delhi, Delhi",

  //     addressLocality: "Delhi",

  //     addressRegion: "Delhi",

  //     postalCode: "110001",

  //     addressCountry: "IN",
  //   },
  // };

  return (
    <>
      <Helmet defer={false}>
        <title>
          Holypills Subscription Plans – Personalized Women’s Health Care
        </title>
        <meta
          name="description"
          content="Choose from flexible Holypills plans for women’s health. Consult online with trusted homeopathy doctors & nutritionists for holistic healing."
        />
        <meta property="og:image" content="/src/assets/images/ogImage.jpg" />
        <meta name="twitter:image" content="/src/assets/images/ogImage.jpg" />
        <link rel="canonical" href="https://holypills.in/healthplan"></link>

        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Holypills Subscription Plans – Personalized Women’s Health Care"
        />
        <meta
          property="og:description"
          content="Choose from flexible Holypills plans for women’s health. Consult online with trusted homeopathy doctors & nutritionists for holistic healing."
        />

        <meta property="og:url" content="https://holypills.in/healthplan" />
        <meta property="og:site_name" content="Holypills"></meta>

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Holypills Subscription Plans – Personalized Women’s Health Care"
        />
        <meta
          name="twitter:description"
          content="Choose from flexible Holypills plans for women’s health. Consult online with trusted homeopathy doctors & nutritionists for holistic healing."
        />
        <meta
          name="twitter:url"
          content="https://holypills.in/healthplan"
        ></meta>
        {/* <script type="application/ld+json">
          {JSON.stringify(orgnaizationData)}
        </script> */}
      </Helmet>
      <div className="wrapper_health_plan_page wrapper_pcos_page">
        <section className="wrapper_journey">
          <div className="container">
            <div className="wrap_cards_journey">
              <div className="wrap_left">
                <h1>
                  Find the right Health Plan
                  <span>For your Wellness Journey</span>
                </h1>
                <p>
                  Our plans designed to support your health at every stage—
                  <span className="block"></span>choose the one that fits your
                  needs best.
                </p>
                <Link className="button" to="/healthplan/#healthplan">
                  Explore Plans <img src={arrow_icon} alt="explore-icon" />
                </Link>
              </div>
              <div className="wrap_right">
                <figure>
                  <img src={steptodownimg} alt="icon" />
                </figure>
              </div>
            </div>
          </div>
        </section>

        <section className=" wrapper_pcos wrapper_what_cause spacing">
          <div className="container">
            <div className="wraper_cards">
              <div className="wrap_right">
                <figure>
                  <img src={compareimg} alt="image" />
                </figure>
              </div>
              <div className="wrap_left">
                <h2>
                  Compare Our Health Plans & <span></span> Choose the Best for
                  Yourself
                </h2>
                <p></p>
                <ul>
                  <li>
                    <img src={liheart} alt="heart-icon" />
                    <span>
                      All our plans offer expert consultations and personalized
                      care—choose based on your preferred duration.
                    </span>
                  </li>
                  <li>
                    <img src={liheart} alt="heart-icon" />
                    <span>
                      Longer plans offer more consultations, ensuring continuous
                      guidance for your health journey.
                    </span>
                  </li>
                  <li>
                    <img src={liheart} alt="heart-icon" />
                    <span>
                      No hidden charges—just simple, transparent pricing of each
                      plan for the care and consultation you deserve.
                    </span>
                  </li>
                  <li>
                    <img src={liheart} alt="heart-icon" />
                    <span>
                      Select a plan that best suits your needs and head start
                      your journey towards better health and growth today!
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section
          className="wrapper_health_plan_table spacing"
          id="healthplan"
          tabIndex={0}
        >
          <OurHealthPlan />
        </section>

        <section className=" container spacing">
          <div className="booking_content">
            <div className="container_flex_wrap">
              <div className="image_wrap">
                <img src={bookingImg} alt="booking-image" />
              </div>
              <div className="content">
                <h4>
                  Book Your <br /> Consultation. <img src={QRcodeImg} alt="qr-image" />
                </h4>
                <h6>Download Our App for Free</h6>
                <p>
                  Are you ready to revolutionize Telehealth & telemedicine app
                  with AI. Then let’s download today.
                </p>

                <div className="button_wrap button_left">
                  <Link to="" target="_blank">
                    <img src={iosButton} alt="app-icon" />
                  </Link>
                  <Link to="" target="_blank">
                    <img src={androidButton} alt="app-icon" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default HealthPlan;
